/**
 * Adapter - CardLifeTypePieceAdapter
 *
 * Appelle GET /api/v1/biotransac/types-pieces pour récupérer
 * la liste dynamique des types de pièces d'identité.
 */

import { ITypePieceService, TypePieceDTO } from '../../application/ports/output/ITypePieceService';

const ENV = (import.meta as ImportMeta & { env?: Record<string, string | undefined> }).env ?? {};
const CARDLIFE_BASE_URL = (ENV.VITE_CARDLIFE_BASE_URL ?? '').replace(/\/+$/g, '');
const TYPES_PIECES_ENDPOINT = '/api/v1/biotransac/types-pieces';

export class CardLifeTypePieceAdapter implements ITypePieceService {
  private cache: TypePieceDTO[] | null = null;

  async getTypesPieces(): Promise<TypePieceDTO[]> {
    // Cache simple en mémoire (les types changent rarement)
    if (this.cache) {
      return this.cache;
    }

    const url = `${CARDLIFE_BASE_URL}${TYPES_PIECES_ENDPOINT}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
      });

      if (!response.ok) {
        console.error('[TypePiece] Erreur:', response.status);
        throw new Error(`Erreur chargement types pièces: ${response.status}`);
      }

      const data: TypePieceDTO[] = await response.json();
      this.cache = data;
      return data;
    } catch (error) {
      console.error('[TypePiece] Erreur chargement types pièces:', error);
      // Fallback hardcodé en cas d'erreur réseau
      return [
        { id: 0, code: 'CNI', libelle: "Carte Nationale d'Identité" },
        { id: 0, code: 'PASSEPORT', libelle: 'Passeport' },
        { id: 0, code: 'PERMIS', libelle: 'Permis de conduire' },
      ];
    }
  }
}
